import classNames from 'classnames';
import { PropsWithChildren } from 'react';

import style from './gradient-border-card.module.css';

type CardBackgroundColor = 'black' | 'white';

type BorderWidth = 1 | 2;

interface GradientBorderCardProps {
  backgroundColor: CardBackgroundColor;
  borderWidth?: BorderWidth;
  className?: string;
  containerClassName?: string;
}

const borderWidthMap: Record<BorderWidth, string> = {
  /* eslint-disable @typescript-eslint/naming-convention */
  1: style.gradientBorderCardOnePixel,
  2: style.gradientBorderCardTwoPixel,
  /* eslint-enable @typescript-eslint/naming-convention */
};

const cardBackgroundColorMap: Record<CardBackgroundColor, string> = {
  black: style.gradientCardBlack,
  white: style.gradientCardWhite,
};

/*
This component is used to compose a card with a gradient border around it.
A border cannot have a gradient, so we are manufacturing the appearance of a
gradient border by placing the card inside a div with a gradient background.
A border-image can be used to create a gradient border, but it does not support border-radius.
*/
const GradientBorderCard = ({
  backgroundColor,
  borderWidth = 2,
  children,
  className,
  containerClassName,
}: PropsWithChildren<GradientBorderCardProps>) => {
  return (
    // This div is here to fix a bug on Firefox where the gradient background grows to fill it's container
    <div>
      <div className={classNames(borderWidthMap[borderWidth], style.gradientBorderCardBackground, containerClassName)}>
        <article
          className={classNames(
            cardBackgroundColorMap[backgroundColor],
            style.gradientCard,
            className,
          )}
        >
          {children}
        </article>
      </div>
    </div>
  );
};

export default GradientBorderCard;
